enum TicketSeverityType {
  NOT_ASSIGNED = 'Not Assigned',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export default TicketSeverityType;
